import axios from "@/lib/axios";

export type AddEvidenceToQuizResponseRequestParamsItem = {
  resourceId: string;
  reference: string;
  comment: string;
};

export type AddEvidenceToQuizResponseRequestParams = {
  companyId: string;
  quizId: string;
  responseId: string;
  resources: AddEvidenceToQuizResponseRequestParamsItem[];
};

export type AddEvidenceToQuizResponseResponse = void;

export const addEvidenceToQuizResponse = (
  params: AddEvidenceToQuizResponseRequestParams,
) =>
  axios
    .post<AddEvidenceToQuizResponseResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.quizId}/responses/${params.responseId}/evidences`,
      params.resources,
    )
    .then((res) => res.data);
